import React from "react";
import "containers/Account/Login/Login.css";
import AxiosConfig from "axiosConfig";
import TextTheme from "components/General/Text/TextTheme";
import { connect } from "react-redux";
import NormalButton from "components/General/Form/CustomButton/NormalButton";
import * as CONSTANT from "constants/text";
import { withRouter } from "react-router-dom";
import CustomInput from "components/General/Form/CustomInput";
import { FaCheckCircle } from "react-icons/fa";

class Login_Form extends React.Component {
  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
    this.state = { username: "", password: "", status: "", errors: [] };
  }

  componentDidMount() {
    const loginButtonElement = document.getElementById("Login");
    if (loginButtonElement) {
      loginButtonElement.remove();
    }

    const bannerImageElement = document.getElementById(
      "unregister-banner-image"
    );
    if (bannerImageElement) {
      bannerImageElement.style.float = "None";
    }

    const bannerImageAElement = document.getElementById(
      "a-unregister-banner-image"
    );
    if (bannerImageAElement) {
      bannerImageAElement.style.float = "None";
      bannerImageAElement.style.margin = "auto";
      bannerImageAElement.style.removeProperty("width");
    }

    sessionStorage.removeItem("registerEmail");
    sessionStorage.removeItem("registerName");
  }

  login(e) {
    e.preventDefault();
    let valid = true;
    if (this.state.username === "" || this.state.username.size === 0) {
      this.showValidationErr("username", CONSTANT.EMPTY_USERNAME);
      valid = false;
    } else {
      if (this.state.username === "") {
        valid = false;
        this.showValidationErr("username", CONSTANT.EMPTY_USERNAME);
      }
    }

    if (this.state.password === "") {
      this.showValidationErr("password", CONSTANT.EMPTY_PASSWORD);
      valid = false;
    }

    if (valid === true) {
      this.handleValidateUser(this);
    }
  }

  handleValidateUser(obj, event) {
    AxiosConfig.post(`account/login/`, this.state)
      .then(function (response) {
        obj.updateResponseStatus(response);
      })
      .catch(function (error) { });
  }

  updateResponseStatus(response) {
    let response_status = response.data["status"];
    if (response_status === CONSTANT.BACKEND_SUCCESS) {
      let userList = response.data["user_list"];
      sessionStorage.setItem("userList", JSON.stringify(userList));
      sessionStorage.setItem("userEmail", userList[0]["email"]);
      sessionStorage.setItem("loggedInUser", userList[0]["email"]);
      if ("onboarding" in response.data) {
        this.props.dispatch({ type: "REGISTER_SUCCESS" });
      } else {
        this.props.dispatch({ type: "LOGIN_SUCCESS" });
        setTimeout(()=>{
         window.location.assign("/home");
        },0)
      }
    } else {
      this.setState((prevState) => ({
        status: response_status,
      }));
    }
  }

  showValidationErr(elm, msg) {
    this.setState((prevState) => ({
      errors: [...prevState.errors, { elm, msg }],
    }));
  }

  clearValidationErr(elm) {
    this.setState((prevState) => {
      let newArr = [];
      for (let err of prevState.errors) {
        if (elm !== err.elm) {
          newArr.push(err);
        }
      }
      return { errors: newArr, status: "" };
    });
  }

  onUsernameChange(e) {
    this.setState({ username: e.target.value });
    this.clearValidationErr("username");
  }

  onPasswordChange(e) {
    this.setState({ password: e.target.value });
    this.clearValidationErr("password");
  }

  render() {
    let usernameErr = null,
      passwordErr = null;
    for (let err of this.state.errors) {
      if (err.elm === "username") {
        usernameErr = err.msg;
      }
      if (err.elm === "password") {
        passwordErr = err.msg;
      }
    }

    const loginStatusMessage = () => {
      switch (this.state.status) {
        case CONSTANT.BACKEND_INCORRECT_EMAIL_OR_PASSWORD:
          return CONSTANT.INCORRECT_LOGIN;
        case CONSTANT.BACKEND_DISABLED_USER:
          return CONSTANT.USER_ACCOUNT_DISABLED;
        case CONSTANT.BACKEND_ACTIVATE_ACCOUNT:
          return CONSTANT.USER_ACCOUNT_NOT_ACTIVATED;
        case CONSTANT.DOES_NOT_EXISTS:
          return CONSTANT.INVALID_ACCOUNT_DETAILS
        default:
          return this.state.status;
      }
    };

    return (
      <div className="login-form">
        {this.props.location.state && !this.props.location.state.isVerify ? (
          <div className="verification">
            <h4>
              <span>
                <FaCheckCircle size={20} style={{ fill: "#008000" }} />
              </span>
              A verification link has been sent to your email account
            </h4>
            <hr></hr>
            <p>
              Please click on the link that has just been sent to your email
              account to verify your email and continue the registration
              process.
            </p>
          </div>
        ) : null}

        <form className="login__form" name="form" method="POST">
          <div className="form-item">
            <CustomInput
              name="username"
              error={usernameErr}
              placeholder="Username"
              value={this.state.username}
              handleChange={this.onUsernameChange.bind(this)}
              handleBlur={this.onUsernameChange.bind(this)}
            />
          </div>

          <div className="form-item">
            <CustomInput
              name="password"
              error={passwordErr}
              placeholder="Password"
              value={this.state.password}
              handleChange={this.onPasswordChange.bind(this)}
              handleBlur={this.onPasswordChange.bind(this)}
              type="password"
            />
          </div>

          <div className="login__field">
            <NormalButton
              handleClick={this.login}
              className="submit-button"
              title="Log In"
            />
            <a className="greytext" href="/register-step-one">
              Don't have an account?
            </a>
            <a className="subtext" href="/forgot-password">
              Forgot username/password
            </a>
          </div>
          <br />

          <TextTheme
            message={loginStatusMessage()}
            className="text_small text_red"
          />
          {this.state.status === CONSTANT.BACKEND_ACTIVATE_ACCOUNT ? (
            <div>
              <a className="subtext" href="/resend-activation">
                Resend activation link
              </a>
            </div>
          ) : null}
        </form>
      </div>
    );
  }
}

export default connect()(withRouter(Login_Form));
